export type PasswordWithConfirmT = {password: string; confirmPassword: string};
export type PasswordWithEmailT = {password: string; email: string; captchaToken: string};

export type ActingAsT = 'speculator' | 'admin' | 'superAdmin';

export const VALID_ACCOUNT_TYPES = ['distributor', 'retailer', 'brand', 'speculator'] as const;
export type AccountTypeT = (typeof VALID_ACCOUNT_TYPES)[number];

export type authenticationT = {
  createdAt?: Date;
  updatedAt?: Date;
  removedAt?: Date;
  token?: string;
  provider?: {
    facebook?: {
      accessToken: string;
      idToken: string;
      providerId: string;
      signInMethod: string;
    };
    google?: {
      accessToken: string;
      idToken: string;
      providerId: string;
      signInMethod: string;
    };
    email?: {
      accessToken: string;
    };
    phone?: {
      accessToken: string;
      idToken: string;
      providerId: string;
      signInMethod: string;
    };
  };
};
